/** The optional translation widget belongs to the document, not to each menu instance. */
export function initialiseTranslationFallback(language: string, doc: Document = document, browser: any = window): void {
  const scriptId = 'flowmaps-google-translation';
  // English is the source language. Loading a translator there adds no translation,
  // but does run its asynchronous DOM replacement/disposal machinery.
  if (language === 'en' || doc.getElementById(scriptId)) return;
  const target = doc.getElementById('google_translate_element');
  if (!target) return;
  let initialized = false;
  browser.googleTranslateElementInit = () => {
    if (initialized) return;
    initialized = true;
    let timer: number;
    const stop = () => { observer.disconnect(); browser.clearTimeout(timer); };
    const applyLanguage = () => {
      const select = target.querySelector('select');
      if (!select || !Array.from(select.options).some(option => option.value === language)) return false;
      if (select.value !== language) {
        select.value = language;
        select.dispatchEvent(new Event('change'));
      }
      return true;
    };
    const observer = new browser.MutationObserver(() => { if (applyLanguage()) stop(); });
    observer.observe(target, {childList: true, subtree: true});
    timer = browser.setTimeout(stop, 10000);
    new browser.google.translate.TranslateElement({pageLanguage: 'en'}, target.id);
    if (applyLanguage()) stop();
  };
  const script = doc.createElement('script');
  script.id = scriptId;
  script.async = true;
  script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
  doc.head.appendChild(script);
}
